import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { MultimediaUpload } from '@app/src/common/MultimediaUpload';
import {
  WrapperPreviewPrint,
  TitlePrint,
  WordPrint,
  StarWrapper,
  StarDoubleWrapper,
  Header,
  IconCheckWrapper,
  Vignette,
  IconEditWrapper,
  IconVignetteWrapper
} from './styled';

interface Props {
  title?: string;
  words: string;
  bold?: boolean;
  className?: string;
  titleCenter?: boolean;
  highlight?: boolean;
  starCount?: number;
  header?: string;
  colorTheme?: string;
  vignette?: boolean;
  handleClickEditVignette?: Function;
  isShowPhotoUploader?: boolean;
  vignetteValue?: string;
  channelId?: number;
  imageDefault?: string;
  isEditable?: boolean;
  heightPhoto?: string;
}

const enum STAR {
  SIMPLE = 1,
  DOUBLE = 2
}

const enum HEADER {
  SIMPLE = 'simple',
  DOUBLE = 'doble',
  MIN_WORD = 2
}

export const PreviewPrint: React.FC<Props> = ({
  title,
  words,
  bold,
  className,
  titleCenter,
  highlight,
  starCount,
  header,
  colorTheme,
  vignette,
  handleClickEditVignette,
  isShowPhotoUploader,
  vignetteValue,
  channelId,
  imageDefault,
  isEditable,
  heightPhoto
}) => {

  const formatTitleHeader = (text: string, header: string) => {
    if (header === HEADER.DOUBLE) {
      if (text.split(/ (.*)/).length >= HEADER.MIN_WORD) {
        return text.split(/ (.*)/);
      }
      return [text, null];
    }
    return [text];
  };

  return(
  <WrapperPreviewPrint
    className={className}
    highlight={highlight}>
    { isShowPhotoUploader &&
      <MultimediaUpload
        height={heightPhoto}
        isShowIconClose={isEditable}
        imageSrc={imageDefault}
        colorTheme={colorTheme}
        channelId={channelId} />}
    {
      vignette &&
      <Vignette>
        <IconVignetteWrapper>
          <Icon data-name="icon-check-vignette" width="17" height="17" fill="#ff0000" />
        </IconVignetteWrapper>
        <TitlePrint block><p>{vignetteValue || 'Ninguno'}</p></TitlePrint>
        {
          handleClickEditVignette &&
          <IconEditWrapper color={colorTheme} onClick={e => handleClickEditVignette(e)}>
            <Icon data-name="icon-pencil" width="17" height="17" fill="#fff" />
          </IconEditWrapper>
        }
      </Vignette>
    }
    {
      (header === HEADER.SIMPLE || header === HEADER.DOUBLE) &&
      <Header>
        <IconCheckWrapper>
          <Icon data-name="icon-check-cursive" width="13" height="13" fill="#fff" />
        </IconCheckWrapper>
        <TitlePrint block>
          {
            formatTitleHeader(title, header).map((item, index) => item === null ? <br key={index} /> : <p key={index}>{item}</p>)
          }
        </TitlePrint>
      </Header>
    }
    <WordPrint bold={bold}>
      {
        title && !header &&
        <TitlePrint center={titleCenter}>
          {
            (starCount === STAR.SIMPLE || starCount === STAR.DOUBLE) &&
            <StarWrapper>
              <Icon data-name="icon-star" width="10" height="10" />
            </StarWrapper>
          }
          {title}
          {
            (starCount === STAR.DOUBLE) &&
            <StarDoubleWrapper>
              <Icon data-name="icon-star" width="10" height="10" />
            </StarDoubleWrapper>
          }
        </TitlePrint>
      }
      {words}
    </WordPrint>
  </WrapperPreviewPrint>
)};
